<span class="header-username-tile__text" [title]="displayName">{{
  displayName
}}</span>
